import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import { NotQuiteAURL } from "web/script/utils/url";

const DEEPLINK_PARAMS_WHITELIST = new Set(["q", "term", "gender"]);

export enum RawAdjustLink {
    DesignerUpdates = "https://lyst.app.link/KpHF8KyBZ3",
    SaveForLater = "https://lyst.app.link/4fHObAlxZ3",
    Footer = "https://lyst.go.link/9UfSM",
    AppPage = "https://lyst.app.link/84mTCgEAd6",
    AppTeaser = "https://lyst.go.link/aqrOd",
    ShowMore = "https://lyst.app.link/KJLyM3c0Q6",
    ComparePrices = "https://lyst.app.link/bK2Ohz8WX6",
    OutOfStockShowMore = "https://lyst.app.link/IQxqsiBh96",
    InStockShowMore = "https://lyst.app.link/T68wuPvh96",
    Homepage = "https://lyst.app.link/rcdNHcFLL7",
    InStockShopNow = "https://lyst.app.link/TlNFPzNPO7",
    OOSGoToRetailer = "https://lyst.app.link/UXDONsGuubb ",
    AppSignupS4L = "https://lyst.app.link/9y2ZaHeprdb",
    AppSignupBIS = "https://lyst.app.link/DPnaBnaprdb",
    AppSignupDU = "https://lyst.app.link/1zhPVs7ordb",
    AppSignupTimedBlock = "https://lyst.app.link/oIejTjm46gb",
    OOSNotifyMe = "https://lyst.app.link/F8J1fQuc9hb",
    ProductCardGeneralFeed = "https://lyst.app.link/SlNFPzNPO7",
    ProductCardGeneralFeedClick2 = "https://lyst.app.link/lJmoADpr0lb",
    ProductCardGeneralFeedClick3 = "https://lyst.app.link/7l0ueRur0lb",
    ProductCardGeneralFeedClick4 = "https://lyst.app.link/pRGgvjzr0lb",
    ProductCardISPDPRelatedFeed = "https://lyst.app.link/VlNFPzNPO7",
    HardBlockInStockShopNow = "https://lyst.app.link/pP2lfP5c4kb",
    PasswordResetComplete = "https://lyst.app.link/account/login",
    PageNotFound = "https://lyst.go.link/7B4HX",
    SizeOOSAlertMe = "https://lyst.app.link/TKAyDzsbqob",
    FollowNewArrivals = "https://lyst.app.link/UF9IZ6nShob",
    GalleryModule = "https://lyst.go.link/hDWSg",
    NavigationMenu = "https://lyst.app.link/4iMEbxfQprb",
    MySizesOnboarding = "https://lyst.app.link/vghFFbkNmHb",
    RetailerReturnAppPopup = "https://lyst.go.link/?adj_t=253yj4t2&adj_campaign=web_to_app_popup&adj_adgroup=mobile_web&adj_creative=download_app_popup",
}

export enum CampaignRawAdjustLink {
    LeadReturn = "https://lyst.app.link/1xX3NV4Xp7",
    ISPDP = "https://lyst.app.link/2xX3NV4Xp7",
    OOSPDP = "https://lyst.app.link/4xX3NV4Xp7",
    Feed = "https://lyst.app.link/3xX3NV4Xp7",
    SignedInUsers = "https://lyst.app.link/5xX3NV4Xp7",
    Homepage = "https://lyst.app.link/6xX3NV4Xp7",
    TrackEmailInterstitial = "https://lyst.app.link/pR32yrZorab",
}

export enum DesktopCampaignRawAdjustLink {
    Feed = "https://lyst.app.link/oR32yrZorab",
}

export const AdjustLinkCampaignName = {
    [RawAdjustLink.DesignerUpdates]: "Web to App - Designer Updates",
    [RawAdjustLink.SaveForLater]: "Web to App - Save for Later",
    [RawAdjustLink.OOSNotifyMe]: "Web to App - Out of Stock PDP - BIS Button",
    [RawAdjustLink.Footer]: "Web to App - Footer",
    [RawAdjustLink.AppPage]: "Web to App - App landing page Button",
    [RawAdjustLink.AppTeaser]: "Web to App - App landing page Image",
    [RawAdjustLink.ShowMore]: "Web to App - Feed - Show More Button",
    [RawAdjustLink.ComparePrices]: "Web to App - Compare prices link",
    [RawAdjustLink.OutOfStockShowMore]: "Web to App - Out of Stock PDP - Show More Button",
    [RawAdjustLink.InStockShowMore]: "Web to App - In Stock PDP - Show More Button",
    [RawAdjustLink.Homepage]: "Web to App - New Homepage - App module link",
    [RawAdjustLink.InStockShopNow]: "Web to App - In Stock PDP - Shop Now button",
    [RawAdjustLink.OOSGoToRetailer]: "Web to App - Out of Stock PDP - Go Retailer Button",
    [RawAdjustLink.AppSignupS4L]: "Web to App - Signup touchpoint - S4L",
    [RawAdjustLink.AppSignupBIS]: "Web to App - Signup touchpoint - BIS",
    [RawAdjustLink.AppSignupDU]: "Web to App - Signup touchpoint - DU",
    [RawAdjustLink.AppSignupTimedBlock]: "Web to App - Signup touchpoint - Timed",
    [RawAdjustLink.ProductCardGeneralFeed]: "Web to App - Feed - Product card click",
    [RawAdjustLink.ProductCardGeneralFeedClick2]: "Web to App - Feed - Product card click 2",
    [RawAdjustLink.ProductCardGeneralFeedClick3]: "Web to App - Feed - Product card click 3",
    [RawAdjustLink.ProductCardGeneralFeedClick4]: "Web to App - Feed - Product card click 4",
    [RawAdjustLink.ProductCardISPDPRelatedFeed]:
        "Web to App - In Stock PDP - Related Products click",
    [RawAdjustLink.HardBlockInStockShopNow]:
        "Web to App - In Stock PDP - Hard block Shop Now button",
    [RawAdjustLink.PasswordResetComplete]: "Web to App - Reset Password Complete - Log in Click",
    [RawAdjustLink.PageNotFound]: "Web to App - 404",
    [RawAdjustLink.SizeOOSAlertMe]: "Web to App - In Stock PDP - OOS size",
    [RawAdjustLink.FollowNewArrivals]: "Web to App - In Stock PDP - New Arrivals Module",
    [RawAdjustLink.GalleryModule]: "Web to App - In Stock PDP - Gallery module",
    [RawAdjustLink.NavigationMenu]: "Web to App - Navigation",
    [CampaignRawAdjustLink.LeadReturn]: "Web to App - CSS Lead Return - General",
    [CampaignRawAdjustLink.ISPDP]: "Web to App - In Stock PDP - General",
    [CampaignRawAdjustLink.OOSPDP]: "Web to App - Out of Stock PDP - General",
    [CampaignRawAdjustLink.Feed]: "Web to App - Feed - General",
    [CampaignRawAdjustLink.SignedInUsers]: "Web to App - Signed In Users - General",
    [CampaignRawAdjustLink.Homepage]: "Web to App - Homepage - General",
    [CampaignRawAdjustLink.TrackEmailInterstitial]: "Web to App - Email - Intermediary screen",
    [DesktopCampaignRawAdjustLink.Feed]: "Web to App - Desktop - Feed - General banner",
    [RawAdjustLink.MySizesOnboarding]: "Web to App - My Sizes Onboarding",
    [RawAdjustLink.RetailerReturnAppPopup]: "Web to App - Retailer Return Pop up",
};

export interface AdjustLinkData {
    adj_label: string; // that's our web_session_id
    web_session_id: string;
    page_type: string; // one of ?
    page_sub_type: string;
    web_device_id: string;
    web_pageview_id: string;
    user_id?: string;
    $deeplink_path?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_source?: string;
    utm_content?: string;
    utm_term?: string;
    utm_country?: string;
    utm_grouping?: string;
    utm_keywords?: string;
    atc_medium?: string;
    atc_campaign?: string;
    atc_country?: string;
    atc_grouping?: string;
    atc_keywords?: string;
    atc_source?: string;
    atc_content?: string;
    atc_term?: string;
    atc_remarketing?: string;
}

export interface AdjustMetaData {
    trafficSource: string;
    lifeCycleStage: string;
    isReturningUser: boolean;
    country: string;
    domain: string;
    page_sub_type: string;
    page_type: string;
    initial_page_sub_type: string;
    initial_page_type: string;
    user_id?: string;
}

export interface SimpleAnalyticsEvent {
    type: string;
    data: {
        category: string;
        action: string;
        label?: string;
        life_cycle_stage: string;
        returning_user: boolean;
        country: string;
        domain: string;
        page_sub_type: string;
        page_type: string;
        initial_page_sub_type: string;
        initial_page_type: string;
        user_id: number | null;
    };
}

function addAttributionData(linkData: AdjustLinkData): AdjustLinkData {
    let trafficAttribution = analytics.getTrafficAttribution();
    if (trafficAttribution) {
        Object.keys(trafficAttribution).forEach((key) => {
            if (trafficAttribution[key] === null) {
                delete trafficAttribution[key];
            }
        });
    }
    return { ...linkData, ...trafficAttribution };
}

export function getAdjustCampaignName(adjustLink: string): string {
    return AdjustLinkCampaignName[adjustLink] || "";
}

function validateSearchParams(search: string): string {
    const deeplinkSearchParams = new URLSearchParams();
    const searchParams = new URLSearchParams(search);

    searchParams.forEach((value, key) => {
        if (DEEPLINK_PARAMS_WHITELIST.has(key)) {
            deeplinkSearchParams.append(key, value);
        }
    });

    return deeplinkSearchParams.toString();
}

export function getLinkData(appDeepLinkURL?: URL | NotQuiteAURL): AdjustLinkData {
    const pageType = environment.get("pageType");
    const pageSubType = environment.get("pageSubType");
    let adjustLinkData: AdjustLinkData = {
        adj_label: analytics.getSessionId(),
        web_session_id: analytics.getSessionId(),
        page_type: pageType,
        page_sub_type: pageSubType,
        web_device_id: analytics.getDeviceUid(),
        web_pageview_id: analytics.getPageViewId(),
    };
    adjustLinkData = addAttributionData(adjustLinkData);
    const userId = environment.get("userId");
    if (userId) {
        adjustLinkData.user_id = userId;
    }

    let validDeepLinkURL;
    if (appDeepLinkURL) {
        validDeepLinkURL = new URL(`https://lyst.com${appDeepLinkURL.pathname}`);
        validDeepLinkURL.search = validateSearchParams(appDeepLinkURL.search);
    } else {
        validDeepLinkURL = new URL(`https://lyst.com${globals.window.location.pathname}`);
        validDeepLinkURL.search = validateSearchParams(globals.window.location.search);
    }

    adjustLinkData["$deeplink_path"] = validDeepLinkURL.toString();

    return adjustLinkData;
}
